/**
 * Mock customer data for MSP reporting prototype
 * Represents customers under an MSP's management
 */

export interface CustomerData {
  id: number;
  name: string;
  status: 'active' | 'inactive' | 'onboarding';
  last_report: string | null;
  services: string[];
  contact_email: string;
  industry?: string;
  compliance_frameworks?: string[];
}

export const customersMockData: CustomerData[] = [
  {
    id: 1,
    name: 'Acme Corporation',
    status: 'active',
    last_report: '2025-09-28T14:23:00Z',
    services: ['XDR', 'EDR', 'VSS'],
    contact_email: 'security@acmecorp.com',
    industry: 'Healthcare',
    compliance_frameworks: ['HIPAA'],
  },
  {
    id: 2,
    name: 'TechStart Inc',
    status: 'active',
    last_report: '2025-09-30T09:15:00Z',
    services: ['XDR', 'Email Security'],
    contact_email: 'it@techstart.com',
    industry: 'Technology',
  },
  {
    id: 3,
    name: 'Global Services LLC',
    status: 'active',
    last_report: '2025-09-25T16:45:00Z',
    services: ['EDR', 'VSS'],
    contact_email: 'ops@globalservices.com',
    industry: 'Manufacturing',
    compliance_frameworks: ['NIST 800-171'],
  },
  {
    id: 4,
    name: 'Bright Future Academy',
    status: 'active',
    last_report: '2025-09-29T11:30:00Z',
    services: ['XDR', 'Email Security'],
    contact_email: 'it@brightfuture.edu',
    industry: 'Education',
  },
  {
    id: 5,
    name: 'MediCare Partners',
    status: 'active',
    last_report: '2025-09-27T08:00:00Z',
    services: ['XDR', 'EDR', 'VSS', 'Email Security'],
    contact_email: 'security@medicarepartners.com',
    industry: 'Healthcare',
    compliance_frameworks: ['HIPAA'],
  },
  {
    id: 6,
    name: 'Downtown Dental Group',
    status: 'active',
    last_report: '2025-09-26T13:20:00Z',
    services: ['EDR', 'Email Security'],
    contact_email: 'admin@downtowndental.com',
    industry: 'Healthcare',
    compliance_frameworks: ['HIPAA'],
  },
  {
    id: 7,
    name: 'First National Bank',
    status: 'active',
    last_report: '2025-09-30T15:00:00Z',
    services: ['XDR', 'EDR', 'VSS'],
    contact_email: 'security@firstnational.bank',
    industry: 'Financial Services',
    compliance_frameworks: ['NIST 800-171'],
  },
  {
    id: 8,
    name: 'Precision Manufacturing Co',
    status: 'active',
    last_report: '2025-09-24T10:15:00Z',
    services: ['XDR', 'VSS'],
    contact_email: 'it@precisionmfg.com',
    industry: 'Manufacturing',
    compliance_frameworks: ['NIST 800-171'],
  },
  {
    id: 9,
    name: 'Green Energy Solutions',
    status: 'active',
    last_report: '2025-09-28T12:45:00Z',
    services: ['EDR', 'Email Security'],
    contact_email: 'ops@greenenergy.com',
    industry: 'Energy',
  },
  {
    id: 10,
    name: 'Citywide Legal Associates',
    status: 'active',
    last_report: '2025-09-29T14:00:00Z',
    services: ['XDR', 'Email Security'],
    contact_email: 'it@citywidelegal.com',
    industry: 'Legal Services',
  },
  {
    id: 11,
    name: 'Riverside Hospital',
    status: 'active',
    last_report: '2025-09-27T09:30:00Z',
    services: ['XDR', 'EDR', 'VSS', 'Email Security'],
    contact_email: 'security@riversidehospital.org',
    industry: 'Healthcare',
    compliance_frameworks: ['HIPAA'],
  },
  {
    id: 12,
    name: 'Summit Consulting Group',
    status: 'active',
    last_report: '2025-09-26T16:20:00Z',
    services: ['EDR', 'VSS'],
    contact_email: 'it@summitconsulting.com',
    industry: 'Consulting',
  },
  {
    id: 13,
    name: 'Atlas Defense Contractors',
    status: 'active',
    last_report: '2025-09-30T11:00:00Z',
    services: ['XDR', 'EDR', 'VSS'],
    contact_email: 'security@atlasdefense.com',
    industry: 'Defense',
    compliance_frameworks: ['NIST 800-171'],
  },
  {
    id: 14,
    name: 'Mountain View Pharmacy',
    status: 'active',
    last_report: '2025-09-25T14:45:00Z',
    services: ['EDR', 'Email Security'],
    contact_email: 'admin@mountainviewrx.com',
    industry: 'Healthcare',
    compliance_frameworks: ['HIPAA'],
  },
  {
    id: 15,
    name: 'Pacific Northwest Lumber',
    status: 'active',
    last_report: '2025-09-28T10:00:00Z',
    services: ['XDR', 'VSS'],
    contact_email: 'it@pnwlumber.com',
    industry: 'Manufacturing',
  },
  {
    id: 16,
    name: 'Beta Software Labs',
    status: 'onboarding',
    last_report: null,
    services: ['XDR'],
    contact_email: 'devops@betalabs.io',
    industry: 'Technology',
  },
  {
    id: 17,
    name: 'Heritage Insurance Group',
    status: 'active',
    last_report: '2025-09-29T15:30:00Z',
    services: ['XDR', 'EDR', 'Email Security'],
    contact_email: 'security@heritageins.com',
    industry: 'Insurance',
  },
  {
    id: 18,
    name: 'Quantum Retail Solutions',
    status: 'inactive',
    last_report: '2025-08-15T12:00:00Z',
    services: ['EDR'],
    contact_email: 'it@quantumretail.com',
    industry: 'Retail',
  },
  {
    id: 19,
    name: 'Metro Transit Authority',
    status: 'active',
    last_report: '2025-09-27T13:15:00Z',
    services: ['XDR', 'VSS'],
    contact_email: 'security@metrotransit.gov',
    industry: 'Government',
  },
  {
    id: 20,
    name: 'Wellness Medical Center',
    status: 'active',
    last_report: '2025-09-30T08:30:00Z',
    services: ['XDR', 'EDR', 'Email Security'],
    contact_email: 'it@wellnessmedical.com',
    industry: 'Healthcare',
    compliance_frameworks: ['HIPAA'],
  },
];

/**
 * Get active customers only
 */
export const getActiveCustomers = (): CustomerData[] => {
  return customersMockData.filter((c) => c.status === 'active');
};

/**
 * Get customers by compliance framework
 */
export const getCustomersByCompliance = (framework: string): CustomerData[] => {
  return customersMockData.filter((c) => c.compliance_frameworks?.includes(framework));
};

/**
 * Get customers by service
 */
export const getCustomersByService = (service: string): CustomerData[] => {
  return customersMockData.filter((c) => c.services.includes(service));
};

/**
 * Get customer by ID
 */
export const getCustomerById = (id: number): CustomerData | undefined => {
  return customersMockData.find((c) => c.id === id);
};
